import React from "react";
import { Field } from "formik";

import {
  Input as InputElement,
} from "./styles";
import Mask from "./utils/mask";
import TplGroup from "../tpl-group";
import IField from "../../../../interfaces/field";

type IProps = any & IField

const InputMask = ({
  placeholder = "Digite aqui",
  required = false,
  name,
  prefixName = "",
  title,
  type,
  mask,
  onChange,
  ...el
}: IProps): JSX.Element | null => {
  const handleChange = (event: { target: { value: string } }): void => {
    let { value } = event.target;
    if (onChange) {
      onChange(value, el);
    }
    if (el.validations?.includes("email"))value = event.target.value.replace(/\s/g, "");

    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, value);
    }
  };

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      <Field
        type={type || "text"}
        name={`${prefixName}${name}`}
        required={required}
        value={el.values[name]}
        onChange={(event: any) => handleChange(event)}
        placeholder={placeholder || ""}
        as={InputElement}
        disabled={el?.disabled === true}
        mask={Mask(mask)}
      />
    </TplGroup>
  );
};

export default InputMask;
